import { useEffect, useState } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import { authApi } from '@/lib/api/auth.api'
import { Button } from '@/components/ui/button'
import { Heading } from '@/components/ui/Heading'
import { Text } from '@/components/ui/Text'
import Link from '@/routing/Link'

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

type InviteState = 'loading' | 'invalid' | 'redirect'

export default function InviteInfoPage() {
  const { token = '' } = useParams<{ token: string }>()
  const [state, setState] = useState<InviteState>('loading')

  useEffect(() => {
    if (!UUID_RE.test(token)) {
      setState('invalid')
      return
    }
    let cancelled = false
    authApi
      .getInviteInfo(token)
      .then(() => {
        if (!cancelled) setState('redirect')
      })
      .catch(() => {
        if (!cancelled) setState('invalid')
      })
    return () => {
      cancelled = true
    }
  }, [token])

  if (state === 'redirect') {
    return <Navigate to={`/register?invite=${encodeURIComponent(token)}`} replace />
  }

  if (state === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Text color="muted">Loading…</Text>
      </div>
    )
  }

  return (
    <div className="mx-auto flex max-w-md flex-col gap-4 px-6 py-16 text-center" data-testid="invite-info-invalid">
      <Heading level={2}>Invalid invite link</Heading>
      <Text color="muted">This invite link is invalid or has expired.</Text>
      <Button asChild variant="outline">
        <Link href="/login">Back to sign in</Link>
      </Button>
    </div>
  )
}
